import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { IQuotation } from "../quotationModel";
import { ErrorToast } from "../../../components/toast/Toasts";

export const getAllQuotation = createAsyncThunk(
  "Quotation/FindAllQuotation",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Quotation/FindAllQuotation`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getQuotationByID = createAsyncThunk(
  "Quotation/FindByIDQuotation",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Quotation/FindByIDQuotation`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        FirstName: result.FirstName,
        LastName: result.LastName,
        Email: result.Email,
        PhoneNo: result.PhoneNo,
        DateOfBirth: result.DateOfBirth,
        TotalTax: result.TotalTax,
        NoOfProperties: result.NoOfProperties,
        Address: result.Address,
        IsNewComer: result.IsNewComer,
        Dependents: result.Dependents,
        IsActive: result.IsActive ? 1 : 2,
        Services: result.Services
          ? result.Services.map((item: any) => {
              return {
                ServiceID: item.ServiceID ? +item.ServiceID : null,
                ServiceName: item.ServiceName ? item.ServiceName : "",
                Description: item.Description ? item.Description : "",
                Charges: item.Charges ? +item.Charges : null,
                OrderNo: item.OrderNo ? +item.OrderNo : null,
              };
            })
          : [],
      } as IQuotation;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching SeoTag :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
